import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { AccountGroupMembership } from '../models/account.model';
import { GroupCustomSegment } from '../models/group.model';
import {
  getSegmentationSelection,
  getSegmentSelectionNodes,
} from '../segment-selections/segment-selections.helper';

@Component({
  selector: 'app-group-segment-node-picker',
  templateUrl: './group-segment-node-picker.component.html',
})
export class GroupSegmentNodePickerComponent implements OnChanges, OnInit {
  @Input() groupCustomSegments: GroupCustomSegment[];
  @Input() targetCustomSegment: GroupCustomSegment;
  @Input() membership: AccountGroupMembership;
  @Input() readonly = false;
  @Output() selectionChanged = new EventEmitter();
  form = this.fb.group({
    node: [''],
  });

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    if (this.readonly) {
      this.form.get('node').disable();
    }
  }

  ngOnChanges() {
    if (!this.membership) {
      return;
    }

    const targetSelection = getSegmentationSelection(
      this.membership.segment_selections,
      this.targetCustomSegment,
    );
    if (!targetSelection) {
      return;
    }
    const selectionNodes = getSegmentSelectionNodes(
      this.groupCustomSegments,
      targetSelection,
    );
    this.form.patchValue({
      node: selectionNodes,
    });
  }

  controlChanged(nodeName: string) {
    this.selectionChanged.emit(nodeName);
  }
}
